import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

import AppRoutes from "./routes/AppRoutes";

import { content } from "./utils/content";

import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        {/* HTML Meta Tags */}
        <title>{content.meta.title}</title>
        <meta name="description" content={content.meta.description} />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />

        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <AppRoutes />
    </HelmetProvider>
  );
}

export default App;
